<kzn-dialog [title]="dialogTitle" [isActionDisabled]="isInsertDisabled" [actionLabel]="t('insert')" [secondaryActionLabel]="t('cancel')" [resetLabel]="t('reset')" (actionFired)="insertImage()" (secondaryActionFired)="cancelDialog()" [showReset]="true" (onReset)="resetForm()">
  @if (selfSignMode && !isComment && !isStamp) {
  <div class="upload-sign-color-picker">
    <span class="upload-sign-color-picker__label">{{ t('signatureColor') }}</span>
    <div class="upload-sign-color-picker__swatches" role="radiogroup" [attr.aria-label]="t('signatureColor')">
      @for (color of selfSignSignatureColors; track color.id) {
        <button
          type="button"
          class="upload-sign-color-picker__swatch"
          [class.upload-sign-color-picker__swatch--active]="selectedSignatureColor === color.value"
          [style.background-color]="color.value"
          [attr.aria-label]="t(color.labelKey)"
          [attr.aria-checked]="selectedSignatureColor === color.value"
          role="radio"
          (click)="onSignatureColorChange(color.value)">
        </button>
      }
    </div>
  </div>
  }
  @if(isComment) {
  <div id="draw-tab-content" class="tab-content-upload-sign">
    <form novalidate class="upload-sign-comment-form">
      <canvas #commentCanvas height="16" hidden></canvas>
      <mat-form-field appearance="outline" class="upload-sign-comment-field" subscriptSizing="dynamic">
        <mat-label>{{ signService.roleText === 'Reviewer' ? t('commentByReviewer') : t('commentBySigner') }}</mat-label>
        <textarea
          matInput
          [formControl]="docComment"
          autocomplete="off"
          [placeholder]="t('enterComment')"
          rows="10"
          spellcheck="true"></textarea>
        <mat-error>{{ t('pleaseFillField') }}</mat-error>
      </mat-form-field>
    </form>
  </div>
  } @else if (isStamp) {
  <div class="tab-content-upload-sign">
    <input #uploadSignFileInput type="file" accept="image/png, image/jpeg, image/jpg"
      (change)="onFileInputChange($event)" hidden />
    <div class="file-input-sign-container">
      @if (selectedImage) {
      <button mat-button mat-raised-button (click)="uploadSign()">
        {{ t('changeFile') }}
      </button>
      } @else {
      <button mat-button mat-raised-button color="primary" (click)="uploadSign()">
        {{ t('chooseFile') }}
      </button>
      }
      <div class="info-text sign-upload-info-text">
        <span>{{ t('ensureSize') }}</span>
        <span>{{ t('allowedTypes') }}</span>
      </div>
      @if(showMaxFileSizeError) {
      <div class="invalid">{{ Messages.MSG_ERROR_MAX_FILE_SIZE }}</div>
      } @else if(showInvalidFileTypeError) {
      <div class="invalid">{{ Messages.MSG_ERROR_INVALID_FILE_TYPE }}</div>
      }
    </div>
    <img class="image-sign-preview" [src]="selectedImage" />
  </div>
  } @else {
  <mat-tab-group [selectedIndex]="initialTabIndex" (selectedTabChange)="selectedTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>keyboard</mat-icon>
        {{ t('initialsTab') }}
      </ng-template>
      <div id="initials-tab-content" class="tab-content-upload-sign">
        <kzn-upload-sign-initials
          [signerName]="signerName"
          [signatureColor]="selectedSignatureColor"
          (onInitialImageChange)="handleInitialImageChange($event)"></kzn-upload-sign-initials>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>draw</mat-icon>
        {{ t('drawTab') }}
      </ng-template>
      <div id="draw-tab-content" class="tab-content-upload-sign">
        <signature-pad style="background-color: transparent" #signature [options]="signaturePadOptions"
          (drawEnd)="drawComplete($event)"></signature-pad>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>cloud_upload</mat-icon>
        {{ t('uploadTab') }}
      </ng-template>
      <div class="tab-content-upload-sign">
        <input #uploadSignFileInput type="file" accept="image/png, image/jpeg, image/jpg"
          (change)="onFileInputChange($event)" hidden />
        <div class="file-input-sign-container">
          @if (selectedImage) {
          <button mat-button mat-raised-button (click)="uploadSign()">
            {{ t('changeFile') }}
          </button>
          } @else {
          <button mat-button mat-raised-button color="primary" (click)="uploadSign()">
            {{ t('chooseFile') }}
          </button>
          }
          <div class="info-text sign-upload-info-text">
            <span>{{ t('ensureSize') }}</span>
            <span>{{ t('allowedTypes') }}</span>
          </div>
          @if(showMaxFileSizeError) {
          <div class="invalid">{{ Messages.MSG_ERROR_MAX_FILE_SIZE }}</div>
          } @else if(showInvalidFileTypeError) {
          <div class="invalid">{{ Messages.MSG_ERROR_INVALID_FILE_TYPE }}</div>
          }
        </div>
        <img class="image-sign-preview" [src]="selectedImage" />
      </div>
    </mat-tab>
    @if (!selfSignMode) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>history</mat-icon>
          <span>{{ t('recentTab') }}</span>
        </ng-template>
        <div id="recent-uploads-tab-content" class="tab-content-upload-sign">
          <kzn-upload-sign-recent-uploads
            (onRecentUploadImageChange)="handleRecentUploadImageChange($event)"></kzn-upload-sign-recent-uploads>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
  }
</kzn-dialog>
